<template>
<div class="row-container">
    <div class="icon-service-container">
        <div class="icon-service-block">
            <img class="icon-service" :src="getProfPhoto">
            <div v-if="!xlScreen" class="inline-block">
                <div v-if="petName || changeUserEnabled" :class="{'inline-block': petName}"><div v-if="petName" v-html="petName"></div><div v-else-if="changeUserEnabled">({{patientName}}) <span @click="showChangeUserAdvice = true" class="change-user" v-html="$t('changeUser')"></span></div></div>
                <div :class="{'inline-block': petName}">
                    <a v-if="profName" :class="{'cursor-default': profSearchDisabled}" class="prof-name" :href="profPage" target="_blank" v-html="profName"></a>
                    <span v-else v-html="$t('unassigned')"></span><span v-if="historyShared" :title="$t('historySharedWithProfessional')">&nbsp;<b-icon-file-earmark-arrow-up></b-icon-file-earmark-arrow-up></span>
                </div>
            </div>
        </div>
    </div>
    <div class="details">
        <div v-if="!xlScreen">
            <span v-html="consultationTitle"></span> <span class="appointment-id">(ID: {{id}})</span>
        </div>
        <div v-else>
            <div v-if="petName || changeUserEnabled" :class="{'inline-block': petName}"><div v-if="petName" v-html="petName"></div><div v-else-if="changeUserEnabled">({{patientName}}) <span @click="showChangeUserAdvice = true" class="change-user" v-html="$t('changeUser')"></span></div></div>
            <div :class="{'inline-block': petName}">
                <a v-if="profName" :class="{'cursor-default': profSearchDisabled}" class="prof-name" :href="profPage" target="_blank" v-html="profName"></a>
                <span v-else v-html="$t('unassigned')"></span><span v-if="historyShared" :title="$t('historySharedWithProfessional')">&nbsp;<b-icon-file-earmark-arrow-up></b-icon-file-earmark-arrow-up></span>
            </div>
        </div>
        <div><span class="clickable" @click="goAppointmentDetailsView" v-html="getDateFormatted(date)"></span></div>
    </div>
    <div v-if="showStateTitle" class="state">
        <div v-if="xlScreen" class="consultation-title">
            <span :title="consultationTitle" v-html="consultationTitle"></span> <span :title="id" class="appointment-id">(ID: {{id}})</span>
        </div>
        <div :title="stateTitle" v-if="stateTitle" v-html="stateTitle"></div>
    </div>
    <div v-if="actionButtons.length > 0" class="actions">
        <div v-if="actionButtons.length <= 2 || !xlScreen">
            <base-button v-for="item in actionButtons" :key="item.title" @click="item.action" :transparent="!item.backgroundColor" :backgroundColor="item.backgroundColor" :borderColor="item.borderColor" :textColor="item.textColor"><span :class="`${item.blink ? 'blink' : ''}`">{{item.title}}</span></base-button>
        </div>
        <div v-else>
            <base-button v-for="item in actionButtons.slice(0, 1)" :key="item.title" @click="item.action" :transparent="!item.backgroundColor" :backgroundColor="item.backgroundColor" :borderColor="item.borderColor" :textColor="item.textColor"><span :class="`${item.blink ? 'blink' : ''}`">{{item.title}}</span></base-button>
            <base-button :id="`more-options-${id}`" transparent :borderColor="GRAY_COLOUR" :textColor="GRAY_COLOUR">{{$t('showOptions')}}</base-button>
            <b-popover :target="`more-options-${id}`" triggers="click blur" placement="top">
              <div class="popover-container">
                <base-button v-for="item in actionButtons.slice(1)" :key="item.title" class="my-3 block" @click="item.action" :transparent="!item.backgroundColor" :backgroundColor="item.backgroundColor" :borderColor="item.borderColor" :textColor="item.textColor"><span :class="`${item.blink ? 'blink' : ''}`">{{item.title}}</span></base-button>
              </div>
            </b-popover>
        </div>
    </div>
    <base-dialog v-model="showChangeUserAdvice" :content="$t('changeUserAdvice')" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :okFn="() => changeUser(patientId)" :cancelFn="() => showChangeUserAdvice = false"></base-dialog>
</div>
</template>

<script>
import { getConsultationIconById, getConsultationTitleById } from '@/constants/consultationTypes'
import BaseButton from '@/components/base/buttons/BaseButton'
import { appointmentDateFormat } from '@/helpers/date.helpers'
import { SCREEN_XL_GRID_MAX } from '@/constants/mediaQueries'
import BaseDialog from '@/components/base/BaseDialog.vue'
import accountMixin from '@/mixins/account.mixin'
import { SECONDARY, GRAY_COLOUR } from '@/constants/colours'
import { BPopover } from 'bootstrap-vue'

const DEFAULT_PROF_PHOTO = 'static-appopensalud/img/bgs/opt/doctor-male.svg'

export default {
    components: {
        BaseDialog,
        BaseButton,
        BPopover
    },
    mixins: [accountMixin],
    props: {
        id: Number,
        patientId: String,
        serviceType: Number,
        profName: String,
        profPage: String,
        profSearchDisabled: Boolean,
        patientName: String,
        petName: String,
        date: [Date, String],
        stateTitle: String,
        changeUserEnabled: Boolean,
        historyShared: Boolean,
        actionButtons: Array,
        profPhoto: String
    },
    data () {
      return {
        showChangeUserAdvice: false,
        SECONDARY,
        GRAY_COLOUR
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
        goAppointmentDetailsView (e) {
            e.preventDefault()
            this.$helpers.goToPatientWebApp(`appointments/preview/${this.id}`, this.$apiToken)
        },
        getDateFormatted () {
            return appointmentDateFormat(this.date, !this.xlScreen)
        }
    },
    computed: {
        consultationIcon () {
            return getConsultationIconById(this.serviceType)
        },
        consultationTitle () {
            return getConsultationTitleById(this.serviceType)
        },
        xlScreen () {
            return window.innerWidth > SCREEN_XL_GRID_MAX
        },
        getProfPhoto () {
            return this.profPhoto || DEFAULT_PROF_PHOTO
        },
        showStateTitle () {
            return (this.xlScreen && this.consultationTitle) || this.stateTitle
        }
    }
}
</script>

<style lang="scss" scoped>
.row-container{
    position: relative;
    overflow: hidden;
    box-shadow: $custom-shadow;
    padding: $padding-bg;
    border-radius: $border-radius;
    border: $border;
    background-color: $white;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    .icon-service-container{
        flex: 0 0 4%;
        min-width: 55px;
    }
    .details{
        flex: 0 0 33%;
    }
    .state{
        flex: 0 0 25%;
        overflow: hidden;
        color: $gray-600;
        text-align: center;
        > div{
            white-space: pre;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .actions{
        flex: 0 0 38%;
        text-align: right;
        > span {
            cursor: pointer;
            margin-right: 1rem;
        }
    }
    @include media(mobile) {
        img.icon-service{
            display: none;
        }
    }
    @include screen-xl-grid-max {
        padding: 2rem;
        flex-direction: column;
        .icon-service-container{
            flex: 0 0 7%;
            width: 100%;
            text-align: left;
            margin-bottom: 0.5rem;
            // .icon-service-block{
            //     white-space: nowrap;
            //     overflow: hidden;
            // }
        }
        .details{
            width: 100%;
        }
        .actions{
            margin-top: 1rem;
            text-align: left;
            width: 100%;
            .btn{
                display: inline-block;
                margin-right: 1rem;
            }
        }
        .state{
            width: 100%;
            margin-top: 1rem;
            text-align: left;
        }
    }
}
div.actions {
    button {
        margin-right: 0.8rem;
        @include screen-xl-grid-max {        
            display: block;
            margin-right: 0;
            margin-bottom: 1rem;
        }
    }
}
.icon-service{
    width: 45px;
    height: 45px;
    border-radius: 50%;
    @include screen-xl-grid-max {
        width: 35px;
        height: 35px;
    }
}
.change-user{
    color: $blue;
    font-weight: bold;
    font-size: small;
    cursor: pointer;
}
.cursor-default{
    cursor: initial;
}
.inline-block{
    display: inline-block;
}
.blue {
    color: $blue;
}
.green {
    color: $green;
}
.red {
    color: $red;
}
.appointment-id{
    font-size: 9px;
}
.bold{
    font-weight: bold;
}
.prof-name{
    font-size: 1.1rem;
}
.consultation-title{
    color: $black;
}
.popover-container{
    text-align: center;
}
.inline-Block{
  display: inline-block;
}
.block{
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/AppointmentRowPatient.vue